import { render, staticRenderFns } from "./StoreRoleList.vue?vue&type=template&id=3145ce3c&scoped=true&"
import script from "./StoreRoleList.vue?vue&type=script&lang=js&"
export * from "./StoreRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145ce3c",
  null
  
)

export default component.exports